import api from "@/utils/http";

/**
 功能：
 time: 2026/1/6 18:09
 **/
export function getExpendInvoiceConfig() {
    return api.get('/admin/expendInvoice/getSetConfig')
}
/**
 功能：
 time: 2026/1/6 18:09
 **/
export function getExpendInvoiceList(data) {
    return api.post('/admin/expendInvoice/getList', data)
}

/**
 功能：
 time: 2025/12/25 16:02
 **/
export function saveExpendInvoice(data) {
    return api.post('/admin/expendInvoice/eSave', data)
}

/**
 功能：
 time: 2025/12/25 16:02
 **/
export function bindExpendInvoice(data) {
    return api.post('/admin/expendInvoice/bindSave', data)
}

/**
 功能：
 time: 2026/1/7 09:40
 **/
export function oSaveInvoice(data) {
    return api.post('/admin/invoice/oSave', data)
}

/**
 功能：
 time: 2026/1/7 09:50
 **/
export function getExpendInvoiceDetail(inv_id) {
    return api.post('/admin/expendInvoice/getDetail', {inv_id })
}

/**
 功能：
 time: 2026/1/7 10:04
 **/
export function deleteExpendInvoice(inv_id) {
    return api.post('/admin/expendInvoice/del', {inv_id})
}


/**
 功能：
 time: 2026/1/7 10:04
 **/
export function clearExpendInvoice(inv_id) {
    return api.post('/admin/expendInvoice/clear', {inv_id})
}



